import React from 'react'
import { Field } from 'redux-form'
import i18n from '../../translations/i18n';

let TimeframeOptions = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="form-section">
		<div className="subtitle title title-border title-border text-left">
			<h6>{i18n.t('deadline.title', {lng})}</h6>
		</div>
		<p className="small tooltip-text">{i18n.t('deadline.subtitle1', {lng})}<br></br>{i18n.t('deadline.subtitle2', {lng})}</p>
		<div className="row">
			<div className="col-6 form-input">
				<div>
					<label htmlFor="12hDeadline" className="simple-radio">
					<Field
						id="12hDeadline"
						name="deadline"
						component='input'
						type='radio'
						value="12hDeadline"
					/>
					<span className="checkmark"></span>
					{i18n.t('deadline.12h', {lng})}
					</label>
				</div>
			</div>
			<div className="col-6 form-input">
				<div>
					<label htmlFor="24hDeadline" className="simple-radio">
					<Field
						id="24hDeadline"
						name="deadline"
						component='input'
						type='radio'
						value="24hDeadline"
					/>
					<span className="checkmark"></span>
					{i18n.t('deadline.24h', {lng})}
					</label>
				</div>
			</div>
			<div className="col-6 form-input">
				<div>
					<label htmlFor="48hDeadline" className="simple-radio">
					<Field
						id="48hDeadline"
						name="deadline"
						type="radio"
						component='input'
						value="48hDeadline"
					/>
					<span className="checkmark"></span>
					{i18n.t('deadline.48h', {lng})}
					</label>
				</div>
			</div>
			<div className="col-6 form-input">
				<div>
					<label htmlFor="5BusinessDays" className="simple-radio">
					<Field
						id="5BusinessDays"
						name="deadline"
						component='input'
						type='radio'
						value="5BusinessDays"
					/>
					<span className="checkmark"></span>
					{i18n.t('deadline.five_days', {lng})}
					</label>
				</div>
			</div>
			<div className="col-6 form-input">
				<div>
					<label htmlFor="upto2weeks" className="simple-radio">
					<Field
						id="upto2weeks"
						name="deadline"
						component='input'
						type='radio'
						value="upto2weeks"
					/>
					<span className="checkmark"></span>
					{i18n.t('deadline.upto2weeks', {lng})}
					</label>
				</div>
			</div>
		</div>
	</div>
	</div>
	)
  }


  export default TimeframeOptions


// WEBPACK FOOTER //
// ./src/components/common/timeframeOptions.js